import apiClient from './apiClient';

export const getSiteSettings = async () => {
  try {
    const response = await apiClient.get('/settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching public settings:', error);
    throw error;
  }
};
